<style lang="scss" scoped></style>
<template>
  <div class="">
    <div class="pt-12 sm:pt-16 lg:pt-24">
      <div class="max-w-screen-xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto lg:max-w-none">
          <h2
            class="text-lg leading-6 font-semibold text-gray-900 uppercase tracking-wider"
          >
            Pricing
          </h2>
          <p
            class="mt-2 text-3xl leading-9 font-extrabold text-gray-700 sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none"
          >
            Affordable and simple pricing
          </p>
        </div>
      </div>
    </div>
    <div class="mt-8 pb-12  sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
      <div class="Polaris-Layout">
        <div class="Polaris-Layout__Section">
          <div class="relative z-0">
            <div
              class="Polaris-InlineStack"
              style="--pc-inline-stack-align: center; --pc-inline-stack-block-align: start; --pc-inline-stack-wrap: wrap; --pc-inline-stack-gap-xs: var(--p-space-600); --pc-inline-stack-flex-direction-xs: row;"
            >
              <!-- Free Plan -->
              <div
                style="width: 18rem; box-shadow: none; border-radius: 0.75rem; position: relative; z-index: 0;"
              >
                <div
                  class="Polaris-ShadowBevel"
                  style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
                >
                  <div
                    class="Polaris-Box"
                    style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
                    >
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-align: start; --pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-200);"
                      >
                        <h3 class="Polaris-Text--root Polaris-Text--headingLg">
                          Free
                        </h3>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                        >
                          Perfect for getting started with WhatsApp messaging
                        </p>
                      </div>
                      <div
                        class="Polaris-InlineStack"
                        style="--pc-inline-stack-align: start; --pc-inline-stack-block-align: end; --pc-inline-stack-wrap: wrap; --pc-inline-stack-gap-xs: var(--p-space-100); --pc-inline-stack-flex-direction-xs: row;"
                      >
                        <h2 class="Polaris-Text--root Polaris-Text--heading2xl">
                          $0
                        </h2>
                        <div
                          class="Polaris-Box"
                          style="--pc-box-padding-block-end-xs: var(--p-space-200);"
                        >
                          <p class="Polaris-Text--root Polaris-Text--bodySm">
                            / month
                          </p>
                        </div>
                      </div>
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-100);"
                      >
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          100 Manual WhatsApp messages
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          WhatsApp share button
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          WhatsApp Chat button
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Standard support
                        </p>
                      </div>
                      <div
                        class="Polaris-Box"
                        style="--pc-box-padding-block-start-xs: var(--p-space-200); --pc-box-padding-block-end-xs: var(--p-space-200);"
                      >
                        <div
                          class="Polaris-ButtonGroup Polaris-ButtonGroup--fullWidth"
                          data-buttongroup-full-width="true"
                        >
                          <div class="Polaris-ButtonGroup__Item">
                            <button
                              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                              type="button"
                              @click="choosePlan('free')"
                              :disabled="
                                store.plan === 'free' ||
                                  store.plan === 'limited_free'
                              "
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                              >
                                <span
                                  v-if="
                                    store.plan === 'free' ||
                                      store.plan === 'limited_free'
                                  "
                                  >Current Plan</span
                                >
                                <span v-else>Select Plan</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- VIP Plan -->
              <div
                style="width: 18rem; box-shadow: none; border-radius: 0.75rem; position: relative; z-index: 0;"
              >
                <div
                  class="Polaris-ShadowBevel"
                  style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
                >
                  <div
                    class="Polaris-Box"
                    style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
                    >
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-align: start; --pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-200);"
                      >
                        <h3 class="Polaris-Text--root Polaris-Text--headingLg">
                          VIP
                        </h3>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                        >
                          For businesses ready to scale their WhatsApp messaging
                        </p>
                      </div>
                      <div
                        class="Polaris-InlineStack"
                        style="--pc-inline-stack-align: start; --pc-inline-stack-block-align: end; --pc-inline-stack-wrap: wrap; --pc-inline-stack-gap-xs: var(--p-space-100); --pc-inline-stack-flex-direction-xs: row;"
                      >
                        <h2 class="Polaris-Text--root Polaris-Text--heading2xl">
                          $9.99
                        </h2>
                        <div
                          class="Polaris-Box"
                          style="--pc-box-padding-block-end-xs: var(--p-space-200);"
                        >
                          <p class="Polaris-Text--root Polaris-Text--bodySm">
                            / month
                          </p>
                        </div>
                      </div>
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-100);"
                      >
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Everything in Free +
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Unlimited Manual Messages
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Automated messages
                          <a
                            href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true"
                            target="blank"
                            class="text-blue-700 text-sm underline hover:text-blue-900"
                            >(Price per message)</a
                          >
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          WhatsApp CRM
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Email alerts
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Loox Integration
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Priority support
                        </p>
                      </div>
                      <div
                        class="Polaris-Box"
                        style="--pc-box-padding-block-start-xs: var(--p-space-200); --pc-box-padding-block-end-xs: var(--p-space-200);"
                      >
                        <div
                          class="Polaris-ButtonGroup Polaris-ButtonGroup--fullWidth"
                          data-buttongroup-full-width="true"
                        >
                          <div class="Polaris-ButtonGroup__Item">
                            <button
                              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                              type="button"
                              @click="choosePlan('vip')"
                              :disabled="store.plan === 'vip'"
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                              >
                                <span v-if="store.plan === 'vip'"
                                  >Current Plan</span
                                >
                                <span v-else>{{
                                  getTrialButtonContent("vip")
                                }}</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Advanced Plan -->
              <div
                style="width: 18rem;border-radius: 0.75rem; position: relative; z-index: 0;"
              >
                <div
                  class="Polaris-ShadowBevel"
                  style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
                >
                  <div
                    class="Polaris-Box"
                    style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
                    >
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-align: start; --pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-200);"
                      >
                        <h3 class="Polaris-Text--root Polaris-Text--headingLg">
                          Advanced
                        </h3>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                        >
                          For businesses needing complete WhatsApp automation
                        </p>
                      </div>
                      <div
                        class="Polaris-InlineStack"
                        style="--pc-inline-stack-align: start; --pc-inline-stack-block-align: end; --pc-inline-stack-wrap: wrap; --pc-inline-stack-gap-xs: var(--p-space-100); --pc-inline-stack-flex-direction-xs: row;"
                      >
                        <h2 class="Polaris-Text--root Polaris-Text--heading2xl">
                          $29
                        </h2>
                        <div
                          class="Polaris-Box"
                          style="--pc-box-padding-block-end-xs: var(--p-space-200);"
                        >
                          <p class="Polaris-Text--root Polaris-Text--bodySm">
                            / month
                          </p>
                        </div>
                      </div>
                      <div
                        class="Polaris-BlockStack"
                        style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-100);"
                      >
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Everything in Free +
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Unlimited Manual Messages
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Automated messages
                          <a
                            href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true"
                            target="blank"
                            class="text-blue-700 text-sm underline hover:text-blue-900"
                            >(Price per message)</a
                          >
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Automation on own number
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Custom automated templates
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Whatsapp CRM
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Team inbox with 1000 messages
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Marketing Campaigns
                          <a
                            href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true"
                            target="blank"
                            class="text-blue-700 text-sm underline hover:text-blue-900"
                            >(Price per message)</a
                          >
                        </p>
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--subdued"
                        >
                          Priority support
                        </p>
                      </div>
                      <div
                        class="Polaris-Box"
                        style="--pc-box-padding-block-start-xs: var(--p-space-200); --pc-box-padding-block-end-xs: var(--p-space-200);"
                      >
                        <div
                          class="Polaris-ButtonGroup Polaris-ButtonGroup--fullWidth"
                          data-buttongroup-full-width="true"
                        >
                          <div class="Polaris-ButtonGroup__Item">
                            <button
                              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                              type="button"
                              @click="choosePlan('advanced')"
                              :disabled="store.plan === 'advanced'"
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                              >
                                <span v-if="store.plan === 'advanced'"
                                  >Current Plan</span
                                >
                                <span v-else>{{
                                  getTrialButtonContent("advanced")
                                }}</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Header">
            <h2 class="Polaris-Text--root Polaris-Text--headingLg">
              Frequently asked questions
            </h2>
          </div>
          <div class="Polaris-LegacyCard__Section">
            <AccordianItem
              v-for="(faq, index) of faqs"
              :key="index"
              :title="faq.title"
              :content="faq.content"
            />
          </div>
        </div>
      </div>

      <PlanDowngradeModal
        v-if="showPlanDowngradeModal"
        @close="showPlanDowngradeModal = false"
        @downgrade="downgradeToFree('free')"
      ></PlanDowngradeModal>
    </div>
  </div>
</template>

<script>
import { differenceInDays } from "date-fns";

import AccordianItem from "../components/Common/AccordianItem";
import PlanDowngradeModal from "../components/Common/PlanDowngradeModal.vue";

export default {
  name: "Plan",
  components: {
    AccordianItem,
    PlanDowngradeModal
  },
  data() {
    return {
      faqs: [
        {
          title: "Will I be charged for failed messages?",
          content:
            "No, if that's not a WhatsApp number or if we couldn't deliver a message we wouldn't count that message."
        },
        {
          title: "Will the automated messages go from my number?",
          content:
            "Yes with our advanced plan, Your automated messages will be sent from your number and you can also reply to the messages you receive in that number. On Vip Plan messages will be sent from our business number"
        },
        {
          title: "Can I send WhatsApp messages to everybody?",
          content:
            "You can only send it to people who have opted in via checkout."
        }
      ],
      showPlanDowngradeModal: false
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    }
  },
  async created() {
    await this.$store.dispatch("getConfig");
  },
  methods: {
    isNotShopifyStaff(planName) {
      return ["custom", "staff", "staff_business"].indexOf(planName) === -1;
    },
    choosePlan(plan) {
      if (
        plan === "free" &&
        (this.store.plan === "vip" || this.store.plan === "advanced")
      ) {
        this.showPlanDowngradeModal = true;
        return;
      }

      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then(response => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Overview" });
            history.pushState({}, null, "/overview");
          }
        });
    },
    downgradeToFree(plan) {
      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then(response => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Overview" });
            history.pushState({}, null, "/overview");
          }
        });
    },
    openMailer() {
      window.open("mailto:help@carthike.com?subject=plan downgrade", "_blank");
    },
    getTrialButtonContent(plan) {
      const trialDetails = this.$store.getters.getTrailDetails;
      if (trialDetails && trialDetails[plan]) {
        if (this.store.plan === "advanced" && plan === "vip") {
          return "Downgrade";
        }
        if (plan === "vip" && trialDetails.vipTrialStartedAt) {
          const startDate = new Date(trialDetails.vipTrialStartedAt * 1000);
          const daysLeft = 7 - differenceInDays(new Date(), startDate);
          if (daysLeft > 0) {
            return `Resume Trial`;
          }
          return "Upgrade";
        }
        if (plan === "advanced" && trialDetails.advancedTrialStartedAt) {
          const startDate = new Date(
            trialDetails.advancedTrialStartedAt * 1000
          );
          const daysLeft = 7 - differenceInDays(new Date(), startDate);
          if (daysLeft > 0) {
            return `Resume Trial`;
          }
          return "Upgrade";
        }

        return "Upgrade";
      }
      return "Start 7 day Trial";
    }
  }
};
</script>

<style lang="scss" scoped></style>
